import manifest from "./marketing-media.json";

export type MarketingMedia = keyof typeof manifest;

export const marketingMedia = (path: MarketingMedia) =>
  `https://cdn.drate.app/${manifest[path].key}`;
